import { DatasheetPaperFormat, DatasheetPaperFormatConfigProperty } from "./datasheet-printing-settings.types";

export const PRINTABLE_RESULT_DATASHEET_ELEMENT_ID = "DatasheetsResultDatasheetHolder";
export const PRINTABLE_EDITOR_DATASHEET_ELEMENT_ID = "DatasheetsEditorDatasheetHolder";

export const PRINTABLE_DATASHEET_FIELD_ID = "DatasheetDatasheetItem";

export const MARGIN_IN_INCHES = 0.5;
export const WEB_TO_PRINTER_RESOLUTION = 96;

export const PAPER_FORMAT_CONFIG: Record<DatasheetPaperFormat, DatasheetPaperFormatConfigProperty> = {
  [DatasheetPaperFormat.letter]: {
    isoName: "letter",
    widthInInches: 8.5,
    heightInInches: 11.0,
  },
  [DatasheetPaperFormat.legal]: {
    isoName: "legal",
    widthInInches: 8.5,
    heightInInches: 14.0,
  },
  [DatasheetPaperFormat.ledger]: {
    isoName: "ledger",
    widthInInches: 17.0,
    heightInInches: 11.0,
  },
  [DatasheetPaperFormat.A3]: {
    isoName: "A3",
    widthInInches: 11.69,
    heightInInches: 16.54,
  },
  [DatasheetPaperFormat.A4]: {
    isoName: "A4",
    widthInInches: 8.27,
    heightInInches: 11.69,
  },
  [DatasheetPaperFormat.A5]: {
    isoName: "A5",
    widthInInches: 5.83,
    heightInInches: 8.27,
  },
  [DatasheetPaperFormat.B4]: {
    isoName: "B4",
    widthInInches: 9.84,
    heightInInches: 13.9,
  },
  [DatasheetPaperFormat.B5]: {
    isoName: "B5",
    widthInInches: 6.93,
    heightInInches: 9.84,
  },
};